import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useData } from "../../hooks";
import DrainfieldInstallationInspectionForm from "../Components/DrainFieldInstallationInspectionForm";
import { DrainFieldInstallationInspectionInput } from "../Components/DrainFieldInstallationInspectionForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";


// TODO: Add error handling



const EditDrainfieldInstallationPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const path = usePath();
    const editData  = useData<DrainFieldInstallationInspectionInput>(path.current); 
   /* console.log(data);*/
  return editData && applicationId ? (
      <Page.Container>
          <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <DrainfieldInstallationInspectionForm
            id="editDrainfieldInstallationInspectionForm"
            title="Drainfield Installation Inspection"
            action="post"
                      applicationInspectionId={editData?.applicationInspectionId}
                      applicationId={applicationId}
                      returnPath={`/inspectionDetails/${inspectionId}`}
            values={editData}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
              
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditDrainfieldInstallationPage;